exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errorbody[data-v-d3186484] {\n  text-align: center;\n}\n.errorbody h1[data-v-d3186484] {\n  margin-top: 160px;\n  font-size: 26px;\n}\n.errorbody p[data-v-d3186484] {\n  font-size: 15px;\n}\n.errorbody p a[data-v-d3186484] {\n  color: #a26b25;\n  text-decoration: none;\n}\n.venue[data-v-d3186484] {\n  padding-bottom: 90px !important;\n}\n.showtime h1[data-v-d3186484] {\n  margin-top: 30px;\n}\n.showtime p[data-v-d3186484] {\n  margin-bottom: 60px;\n}", ""]);

// exports
